/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../clients/fragments-delivery-api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../clients/fragments-delivery-api-client";
import type { FragmentsDeliveryAPIStationConfigClientGetAllStationsConfigsQueryResponse } from "../models/FragmentsDeliveryAPIStationConfigClientGetAllStationsConfigs";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { fragmentsDeliveryAPIStationConfigClientGetAllStationsConfigs } from "../axios/fragmentsDeliveryAPIStationConfigClientGetAllStationsConfigs";
import { queryOptions, useQuery } from "@tanstack/react-query";

export const fragmentsDeliveryAPIStationConfigClientGetAllStationsConfigsQueryKey = () => ["fragments-delivery-api", { url: '/station-config/all' }] as const

export type FragmentsDeliveryAPIStationConfigClientGetAllStationsConfigsQueryKey = ReturnType<typeof fragmentsDeliveryAPIStationConfigClientGetAllStationsConfigsQueryKey>

export function fragmentsDeliveryAPIStationConfigClientGetAllStationsConfigsQueryOptions(config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const queryKey = fragmentsDeliveryAPIStationConfigClientGetAllStationsConfigsQueryKey()
  return queryOptions<FragmentsDeliveryAPIStationConfigClientGetAllStationsConfigsQueryResponse, ResponseErrorConfig<Error>, FragmentsDeliveryAPIStationConfigClientGetAllStationsConfigsQueryResponse, typeof queryKey>({
 
   queryKey,
   queryFn: async ({ signal }) => {
      config.signal = signal
      return fragmentsDeliveryAPIStationConfigClientGetAllStationsConfigs(config)
   },
  })
}

/**
 * @summary Get all Station configs for a client (client access)
 * {@link /station-config/all}
 */
export function useFragmentsDeliveryAPIStationConfigClientGetAllStationsConfigs<TData = FragmentsDeliveryAPIStationConfigClientGetAllStationsConfigsQueryResponse, TQueryData = FragmentsDeliveryAPIStationConfigClientGetAllStationsConfigsQueryResponse, TQueryKey extends QueryKey = FragmentsDeliveryAPIStationConfigClientGetAllStationsConfigsQueryKey>(options: 
{
  query?: Partial<QueryObserverOptions<FragmentsDeliveryAPIStationConfigClientGetAllStationsConfigsQueryResponse, ResponseErrorConfig<Error>, TData, TQueryData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: typeof fetch }
}
 = {}) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...queryOptions } = queryConfig
  const queryKey = queryOptions?.queryKey ?? fragmentsDeliveryAPIStationConfigClientGetAllStationsConfigsQueryKey()

  const query = useQuery({
   ...fragmentsDeliveryAPIStationConfigClientGetAllStationsConfigsQueryOptions(config),
   queryKey,
   ...queryOptions
  } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<Error>> & { queryKey: TQueryKey }

  query.queryKey = queryKey as TQueryKey

  return query
}